
<template>
  <div id="Test-Report-Form" class="hbn-container">
    <!-- 查询区域 -->
    <el-form
      :inline="true"
      ref="form"
      :model="form"
      size="small"
      label-width="70px"
      label-position="right"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="查询">
            <el-date-picker
              style="width: 45%"
              v-model="SelectData.StartYear"
              value-format="YYYY-MM"
              format="YYYY-MM"
              type="month"
              size="small"
              :default-value="SelectData.StartYear"
            ></el-date-picker>
            至
            <el-date-picker
              style="width: 45%"
              v-model="SelectData.EndYear"
              value-format="YYYY-MM"
              format="YYYY-MM"
              type="month"
              size="small"
              :default-value="SelectData.EndYear"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="省-市-县">
            <el-select
              style="width: 30%"
              v-model="SelectData.ProvinceCode"
              filterable
              placeholder="请选择省"
              @change="ProvinceChange"
            >
              <el-option
                v-for="item in ProvinceList"
                :key="item.code"
                :label="item.areaName"
                :value="item.code"
              >
              </el-option>
            </el-select>

            <el-select
              style="width: 30%"
              v-model="SelectData.CityCode"
              filterable
              placeholder="请选择市"
              @change="CityChange"
            >
              <el-option
                v-for="item in CityList"
                :key="item.code"
                :label="item.areaName"
                :value="item.code"
              >
              </el-option>
            </el-select>

            <el-select
              style="width: 30%"
              v-model="SelectData.RegionCode"
              filterable
              placeholder="请选择区"
            >
              <el-option
                v-for="item in RegionList"
                :key="item.code"
                :label="item.areaName"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item>
            <div class="operation-btn">
              <el-button @click="GetData">查找</el-button>
              <el-button @click="reset">重置</el-button>
              <span @click="onStowChange">{{ isStow ? "收起" : "展开" }}</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="isStow">
        <el-col :span="8">
          <el-form-item label="姓名">
            <el-input
              v-model="SelectData.InjuryUserName"
              placeholder="姓名"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工伤单位">
            <LoadMoreSelector
              v-model="SelectData.injuryUnitRange"
              placeholder="工伤单位"
              url="/api/app/injuryUnit/list"
              :filterable="true"
              :collapse-tags="true"
              :collapse-tags-tooltip="true"
              :multiple="true"
              :remote="true"
              :formater="formater"
              :pageSize="100"
            />
            <!-- <el-select-v2
              size="small"
              style="width: 200px"
              multiple
              placeholder="工伤单位"
              v-model="SelectData.injuryUnitRange"
              remote
              filterable
              collapse-tags
              collapse-tags-toolti
              :remote-method="remoteMethodUnit"
              :options="Units"
            /> -->
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="伤害类型">
            <LoadMoreSelector
              v-model="SelectData.injuryPartRange"
              placeholder="伤害类型"
              url="/api/app/injuryPart/list"
              :filterable="true"
              :collapse-tags="true"
              :collapse-tags-tooltip="true"
              :multiple="true"
              :remote="true"
              :formater="formater"
            />
            <!-- <el-select-v2
              size="small"
              style="width: 200px"
              multiple
              placeholder="伤害类型"
              v-model="SelectData.injuryPartRange"
              remote
              filterable
              collapse-tags
              collapse-tags-toolti
              :remote-method="remoteMethodInjuryPart"
              :options="injuryPartList"
            /> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="isStow">
        <el-col :span="8">
          <el-form-item label="受伤部位">
            <!-- <el-select-v2
              size="small"
              style="width: 200px"
              multiple
              placeholder="受伤部位"
              v-model="SelectData.injurySiteRange"
              remote
              filterable
              collapse-tags
              collapse-tags-toolti
              :remote-method="remoteMethodInjurySite"
              :options="injurySiteList"
            /> -->
            <LoadMoreSelector
              v-model="SelectData.injurySiteRange"
              placeholder="受伤部位"
              url="/api/app/injurySite/list"
              :filterable="true"
              :collapse-tags="true"
              :collapse-tags-tooltip="true"
              :multiple="true"
              :remote="true"
              :formater="formater"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职业病">
            <!-- <el-select-v2
              size="small"
              style="width: 200px"
              multiple
              placeholder="职业病"
              v-model="SelectData.occupationDiseaseRange"
              remote
              filterable
              collapse-tags
              collapse-tags-toolti
              :remote-method="remoteMethodoccupationDisease"
              :options="occupationDiseaseList"
            /> -->
            <LoadMoreSelector
              v-model="SelectData.occupationDiseaseRange"
              placeholder="职业病"
              url="/api/app/occupationDisease/list"
              :filterable="true"
              :collapse-tags="true"
              :collapse-tags-tooltip="true"
              :multiple="true"
              :remote="true"
              :formater="formater"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="所属行业">
            <!-- <el-select-v2
              size="small"
              style="width: 200px"
              multiple
              placeholder="所属行业"
              v-model="SelectData.injuryTypeRange"
              remote
              filterable
              collapse-tags
              collapse-tags-toolti
              :remote-method="remoteMethodinjuryType"
              :options="injuryTypeList"
            /> -->
            <LoadMoreSelector
              v-model="SelectData.injuryTypeRange"
              placeholder="所属行业"
              url="/api/app/injuryType/list"
              :filterable="true"
              :collapse-tags="true"
              :collapse-tags-tooltip="true"
              :multiple="true"
              :remote="true"
              :formater="formater"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="isStow">
        <el-col :span="8">
          <el-form-item label="岗位">
            <el-input v-model="SelectData.post" placeholder="岗位" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="入职时间" prop="entryDate">
            <el-date-picker
              v-model="SelectData.entryDate"
              type="daterange"
              range-separator=" - "
              start-placeholder="开始"
              end-placeholder="结束"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="isStow">
        <el-col :span="8">
          <el-form-item label="年龄范围">
            <div class="ageRange">
              <el-input-number
                v-model="SelectData.ageRangeBegin"
                class="w-50 m-2"
                :suffix-icon="Calendar"
                style="width: 40%"
                :min="0"
                :controls="false"
              />
              <span> &nbsp;-&nbsp; </span>
              <el-input-number
                v-model="SelectData.ageRangeEnd"
                class="w-50 m-2"
                :prefix-icon="Search"
                style="width: 40%"
                :min="0"
                :controls="false"
              />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="SelectData.sex" placeholder="性别">
              <el-option
                v-for="item in SexList"
                :key="item.val"
                :label="item.name"
                :value="item.val"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 主体区域 -->
    <div class="hbn-content">
      <el-tabs type="border-card">
        <el-tab-pane label="图形报表">
          <div class="hbn-operation">
            <el-radio-group v-model="mapType">
              <el-radio label="line">折线图</el-radio>
              <el-radio label="pie">饼状图</el-radio>
              <el-radio label="bar">柱状图</el-radio>
            </el-radio-group>
            <el-input size="small" v-model="titleName"> </el-input>
          </div>
          <div class="screen-item" v-show="mapType === 'line'">
            <div
              id="line-Chart"
              :style="{ width: '100%', height: '400px' }"
            ></div>
          </div>
          <div class="screen-item" v-show="mapType === 'bar'">
            <div
              id="bar-Chart"
              :style="{ width: '100%', height: '400px' }"
            ></div>
          </div>
          <div class="screen-item" v-show="mapType === 'pie'">
            <div
              id="pie-Chart"
              :style="{ width: '100%', height: '400px' }"
            ></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="明细数据">
          <div class="hbn-table-screen">
            <div class="operation">
              <el-button
                type="primary"
                class="custom-button"
                @click="exportExcel"
              >
                <i class="el-icon-download custom-icon"></i>
                <span>导出</span>
              </el-button>
            </div>

            <div class="custom-table-layer">
              <div style="margin-bottom: 13px">
                <vxe-table
                  v-loading="loading"
                  :data="detailedData"
                  round
                  border
                  height="388"
                  class="mytable-scrollbar"
                  style="width: 100%"
                  :highlight-current-row="true"
                  @current-change="handleCurrentChange"
                  @checkbox-change="handleSelectionChange"
                  @checkbox-all="selectAllChangeEvent"
                  ref="multipleTable"
                  highlight-hover-row
                  highlight-hover-column
                  highlight-current-column
                  show-overflow="tooltip"
                  empty-text="没有更多数据了！"
                  resizable
                  stripe
                >
                  <vxe-table-column
                    fixed="left"
                    type="checkbox"
                    width="40"
                  ></vxe-table-column>
                  <vxe-table-column
                    fixed="left"
                    type="seq"
                    width="55"
                    title="序号"
                    align="center"
                  ></vxe-table-column>

                  <template
                    v-for="(item, key) in InjuryAffirmBillList"
                    :key="key"
                  >
                    <vxe-table-column
                      :field="item.prop"
                      :title="item.label"
                      :width="item.width"
                      align="center"
                      v-if="item.isShow"
                      show-overflow-tooltip
                      :class-name="JSON.stringify(item)"
                      :formatter="formatterData"
                    />
                  </template>
                </vxe-table>
              </div>

              <div class="pagination">
                <vxe-pager
                  perfect
                  size="mini"
                  :current-page="PageQuery.PageIndex"
                  :page-size="PageQuery.PageSize"
                  :page-sizes="[20, 50, 100, 500]"
                  :total="total"
                  :pager-count="5"
                  :layouts="[
                    'PrevJump',
                    'PrevPage',
                    'JumpNumber',
                    'NextPage',
                    'NextJump',
                    'FullJump',
                    'Sizes',
                    'Total',
                  ]"
                  @page-change="handlePageChange"
                >
                  <template #left>
                    <span class="page-left">
                      <span>已选中 {{ checkendSum }}</span>
                      <span class="clear" @click.prevent="clearCheckboxRow()"
                        >清空</span
                      >
                    </span>
                  </template>
                </vxe-pager>
                <!-- </div> -->
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import {
  GetInjuryDeadthAlysisData,
  GetInjuryMonthAlysisData,
  GetInjuryPostData,
  GetDataInjuryAffirmBillListByPageQuery,
  ExportInjuryAffirmBill,
} from "@api/ApiInjuryAffirmBill";
import { GetDataDministrativeDivisionsList } from "@api/ApiDministrativeDivisions";
import { Chart } from "highcharts-vue";
import { ProvinceList } from "@/assets/apiData/Province";
import { GetDataInjuryUnitList } from "@api/ApiInjuryUnit";
import { getSystemConfigByKey } from "@/util/authority";

import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsNoData from "highcharts-no-data-to-display";
import loadExporting from "highcharts/modules/exporting";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";

HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
loadExporting(Highcharts);
HighchartsNoData(Highcharts);
import { InjuryAffirmBillList } from "@/assets/apiData/InjuryAffirmBillList";
import { dateFormat } from "@/util/utils.js";
// 自定义分页下拉组件
import LoadMoreSelector from "@comp/SelectorWithLoadMore/index";

export default {
  name: "InjuryMonthAlysis",
  data() {
    return {
      loading: false,
      SelectData: {
        StartYear: (new Date().getFullYear() - 2).toString() + "-01",
        EndYear: new Date().getFullYear().toString() + "-12",
        ProvinceCode: "",
        CityCode: "",
        InjuryUserName: "",
        InjuryUnitName: "",
        injuryUnitRange: [],
        injuryPartRange: [],
        injurySiteRange: [],
        occupationDiseaseRange: [],
        injuryTypeRange: [],
        post: "",
        entryDate: [],
        entryDateBegin: "",
        entryDateEnd: "",
        sex: "",
        ageRangeBegin: "",
        ageRangeEnd: "",
      },
      startPickerOptions: {},
      endPickerOptions: {},
      DataList: [],
      Page2TableDataList: [],
      lang: {
        noData: "没有更多数据了！",
        viewFullscreen: "全屏查看",
        printChart: "打印",
        downloadJPEG: "下载JPEG 图片",
        downloadPDF: "下载PDF文档",
        downloadPNG: "下载PNG 图片",
        downloadSVG: "下载SVG 矢量图",
        exportButtonTitle: "导出图片",
      },
      colors: [
        "#4F94CD",
        "#8487E9",
        "#54CA71",
        "#49A1FF",
        "#59CB74",
        "#FCD44A",
        "#985FE5",
        "#F3657C",
        "#435288",
        "#84E0BE",
        "#EAA676",
        "#8085E9",
        "#058DC7",
        "#50B432",
        "#ED561B",
        "#24CBE5",
        "#64E572",
        "#FF9655",
        "#87CEEB",
        "#7EC0EE",
        "#79CDCD",
        "#7171C6",
        "#C1FFC1",
        "#7FFFD4",
      ],
      Page2TableHeader: [],
      titleName: "折线图",
      ProvinceList: [],
      CityList: [],
      RegionList: [],
      Posts: [], //岗位
      optionPosts: [],
      Units: [], //工伤单位
      optionUnits: [],
      PageQuery: {
        queryModel: {
          name: "",
        },
        pageindex: 1,
        pageSize: 20,
      },
      IsShowReportSubTitle: "0", //报表是否展示标语
      ProvinceList: [],
      CityList: [],
      RegionList: [],
      Posts: [], //岗位
      Units: [], //工伤单位
      optionUnits: [],
      SexList: [
        { name: "男", val: 0 },
        { name: "女", val: 1 },
      ],
      injuryPartList: [],
      injuryPartOpt: [],
      injurySiteList: [],
      injurySiteOpt: [],
      occupationDiseaseList: [],
      occupationDiseaseOpt: [],
      injuryTypeList: [],
      injuryTypeOpt: [],
      isStow: false, // 是否展开  true:展开  false:收起
      mapType: "line", // 地图类型
      InjuryAffirmBillList,
      detailedData: [],
      multipleSelection: [],
      total: 0,
      // 折线图
      lineChartMap: "",
      // 饼图
      pieChartMap: "",
      // 柱状图
      barChartMap: "",
    };
  },
  components: {
    highcharts: Chart,
    LoadMoreSelector,
  },
  watch: {
    mapType(val) {
      switch (val) {
        case "line":
          this.titleName = "折线图";
          break;
        case "pie":
          this.titleName = "饼状图";
          break;
        case "bar":
          this.titleName = "柱状图";
          break;
        default:
          break;
      }
    },
    titleName(val) {
      if (!val) return;
      switch (this.mapType) {
        case "line":
          this.lineChartMap.update({
            exporting: {
              filename: val,
            },
            title: {
              text: val,
            },
          });
          break;
        case "pie":
          this.pieChartMap.update({
            exporting: {
              filename: val,
            },
            title: {
              text: val,
            },
          });
          break;
        case "bar":
          this.barChartMap.update({
            exporting: {
              filename: val,
            },
            title: {
              text: val,
            },
          });
          break;
        default:
          break;
      }
    },
  },
  computed: {
    checkendSum() {
      if (!this.multipleSelection) return 0;
      return this.multipleSelection.length;
    },
  },
  created() {
    this.ProvinceList = JSON.parse(JSON.stringify(ProvinceList.entities));
    this.ProvinceList.unshift({
      areaName: "-请选择-",
      code: "",
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.IsShowReportSubTitle = getSystemConfigByKey("IsShowReportSubTitle");
      this.GetData();
      this.GetDataDministrativeDivisions();
      this.loadData();
    });
  },
  methods: {
    // 下拉框格式化数据
    formater(data) {
      return (
        data &&
        data.map((itm) => ({
          ...itm,
          key: itm.id,
          value: itm.id,
          label: itm.name,
        }))
      );
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS", new Date(cellValue));
          break;
        case "date":
          cellValue = dateFormat("YYYY-mm-dd", new Date(cellValue));
          break;
        case "checkbox":
          cellValue = cellValue == "1" ? "是" : "否";
          break;
        case "status":
          cellValue = cellValue == "1" ? "启用" : "停用";
          break;
      }
      return cellValue;
    },
    // 控制展开/收起
    onStowChange() {
      this.isStow = this.isStow ? false : true;
    },
    loadData() {
      //加载岗位和工伤单位数据
      var _this = this;
      GetInjuryPostData().then(function (data) {
        _this.Posts = data;
        _this.optionPosts = data;
      });
      let PageQuery = {
        queryModel: {
          name: "",
        },
        pageindex: 1,
        pageSize: 100000,
      };
      // GetDataInjuryUnitList(PageQuery).then(function (data) {
      //   _this.Units = data.entities.map((item) => {
      //     return {
      //       ...item,
      //       label: item.name,
      //       value: item.id,
      //     };
      //   });
      // });
      // GetDatainjuryPartList(PageQuery).then(function (data) {
      //   _this.injuryPartList = data.entities.map((item) => {
      //     return {
      //       ...item,
      //       label: item.name,
      //       value: item.id,
      //     };
      //   });
      // });
      // GetDataInjurySiteList(PageQuery).then(function (data) {
      //   _this.injurySiteList = data.entities.map((item) => {
      //     return {
      //       ...item,
      //       label: item.name,
      //       value: item.id,
      //     };
      //   });
      // });
      // GetDataOccupationDiseaseList(PageQuery).then(function (data) {
      //   _this.occupationDiseaseList = data.entities.map((item) => {
      //     return {
      //       ...item,
      //       label: item.name,
      //       value: item.id,
      //     };
      //   });
      // });
      // GetDataInjuryTypeList(PageQuery).then(function (data) {
      //   _this.injuryTypeList = data.entities.map((item) => {
      //     return {
      //       ...item,
      //       label: item.name,
      //       value: item.id,
      //     };
      //   });
      // });
    },
    remoteMethodUnit(query) {
      if (query !== "") {
        this.optionUnits = this.Units.filter((item) => {
          return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.optionUnits = this.Units;
      }
    },
    remoteMethodInjuryPart(query) {
      if (query !== "") {
        this.injuryPartOpt = this.injuryPartList.filter((item) => {
          return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.injuryPartOpt = this.injuryPartList;
      }
    },
    remoteMethodInjurySite(query) {
      console.log(query);
      if (query !== "") {
        this.injurySiteOpt = this.injurySiteList.filter((item) => {
          return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.injurySiteOpt = this.injurySiteList;
      }
    },
    remoteMethodoccupationDisease(query) {
      if (query !== "") {
        this.occupationDiseaseOpt = this.occupationDiseaseList.filter(
          (item) => {
            return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
          }
        );
      } else {
        this.occupationDiseaseOpt = this.occupationDiseaseList;
      }
    },
    remoteMethodinjuryType(query) {
      if (query !== "") {
        this.injuryTypeOpt = this.injuryTypeList.filter((item) => {
          return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.injuryTypeOpt = this.injuryTypeList;
      }
    },
    export2Excel() {
      const v = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径

        const tHeader = [
          ...Enumerable.from(v.Page2TableHeader)
            .select((item) => {
              return item.label;
            })
            .toArray(),
        ]; // 标题
        const filterVal = [
          ...Enumerable.from(v.Page2TableHeader)
            .select((item) => {
              return item.prop;
            })
            .toArray(),
        ]; // 导出的字段名
        const list = v.Page2TableDataList;
        const data = v.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `工伤认定统计-` + v.titleName);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    /**
     * 折线图
     */
    lineChart() {
      const seriesData = [];
      this.DataList.forEach((e) => {
        seriesData.push({
          name: e.year + " 年工伤人数",
          data: e.data,
          lineWidth: 3, // 线宽
          cursor: "pointer", // 鼠标样式
          dashStyle: "Solid", // 线条样式
        });
      });
      // 初始化 Highcharts 图表
      this.lineChartMap = new Highcharts.Chart("line-Chart", {
        credits: {
          enabled: false, // 禁用版权信息
        },
        exporting: {
          filename: this.titleName,
          // filename:
          //   this.SelectData.StartYear +
          //   "-" +
          //   this.SelectData.EndYear +
          //   " 年工伤人数-折线图",
        },
        title: {
          text: this.titleName,
        },
        subtitle: {
          text:
            this.IsShowReportSubTitle == "1"
              ? "数据来源:铁安通工伤预防智能帮手"
              : "",
        },
        colors: this.colors,
        lang: this.lang,
        // X轴
        xAxis: {
          title: {
            text: "月",
          },
          // 数据项
          categories: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
          ],
        },
        // Y轴
        yAxis: {
          title: {
            align: "high",
            textAlign: "left",
            rotation: 0,
            offset: 0,
            margin: 0,
            y: -20,
            x: -15,
            text: "工伤人数",
          },
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
            marker: {
              radius: 1, // 大小
              enabled: true, // 为true时，自定义显示 下方label无效
              states: {
                // 状态
                hover: {
                  radius: 2,
                  lineWidthPlus: 1,
                },
              },
            },
          },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
        series: seriesData,
      });
    },
    /**
     * 饼状图
     */
    pieChart() {
      const seriesData = [];
      this.DataList.forEach((e) => {
        e.data.forEach((eData, index) => {
          seriesData.push({ name: e.year + "-" + (index + 1), y: eData });
        });
      });
      this.pieChartMap = new Highcharts.chart("pie-Chart", {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
        },
        credits: {
          enabled: false, // 禁用版权信息
        },
        colors: this.colors,
        lang: this.lang,
        exporting: {
          filename: this.titleName,
          // filename:
          //   this.SelectData.StartYear +
          //   "-" +
          //   this.SelectData.EndYear +
          //   " 年工伤人数-饼状图",
        },
        title: {
          text: this.titleName,
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
              style: {
                color:
                  (Highcharts.theme && Highcharts.theme.contrastTextColor) ||
                  "black",
              },
            },
          },
        },
        series: [
          {
            name: "工伤人数",
            colorByPoint: true,
            data: seriesData,
          },
        ],
      });
    },
    /**
     * 柱状图
     */
    barChart() {
      const seriesData = [];
      this.DataList.forEach((e) => {
        seriesData.push({
          name: e.year,
          data: e.data,
        });
      });

      // 初始化 Highcharts 图表
      this.barChartMap = new Highcharts.Chart("bar-Chart", {
        credits: {
          enabled: false, // 禁用版权信息
        },
        exporting: {
          filename: this.titleName,
          // filename:
          //   this.SelectData.StartYear +
          //   "-" +
          //   this.SelectData.EndYear +
          //   " 年工伤人数-柱状图",
        },
        title: {
          text: this.titleName,
        },
        chart: {
          type: "column",
        },
        subtitle: {
          text:
            this.IsShowReportSubTitle == "1"
              ? "数据来源:铁安通工伤预防智能帮手"
              : "",
        },
        lang: this.lang,
        // X轴
        xAxis: {
          // 数据项
          categories: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
          ],
        },
        // Y轴
        yAxis: {
          title: {
            align: "high",
            textAlign: "left",
            rotation: 0,
            offset: 0,
            margin: 0,
            y: -20,
            x: -15,
            text: "工伤人数",
          },
          // 标示线
          plotLines: [
            {
              value: 0,
              width: 1,
              color: "#808080",
            },
          ],
        },
        colors: this.colors,
        tooltip: {
          valueSuffix: "人", // 提示信息所带单位
        },
        // legend: {
        //   enabled: false, //  禁用图例
        // },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              y: -5,
              style: {
                fontWeight: "bold",
                fontSize: "10px",
              },
            },
          },
          series: {
            marker: {
              radius: 1, // 大小
              enabled: true, // 为true时，自定义显示 下方label无效
              states: {
                // 状态
                hover: {
                  radius: 2,
                  lineWidthPlus: 1,
                },
              },
            },
          },
        },
        series: seriesData,
      });
    },
    reset() {
      this.SelectData = {
        StartYear: (new Date().getFullYear() - 2).toString() + "-01",
        EndYear: new Date().getFullYear().toString() + "-12",
        ProvinceCode: "",
        CityCode: "",
        InjuryUserName: "",
        InjuryUnitName: "",
        injuryUnitRange: [],
        injuryPartRange: [],
        injurySiteRange: [],
        occupationDiseaseRange: [],
        injuryTypeRange: [],
        post: "",
        entryDate: [],
        entryDateBegin: "",
        entryDateEnd: "",
        sex: "",
        ageRangeBegin: "",
        ageRangeEnd: "",
      };
    },
    GetData() {
      const _this = this;
      // _this.SelectData.UnitIds=""
      // _this.SelectData.Posts=""
      // _this.SelectData.UnitIds=_this.SelectData.UnitIdArr.join(',');
      // _this.SelectData.PostArr.forEach(x=>{
      //    _this.SelectData.Posts+="'"+x+"',";
      // })
      if (_this.SelectData.entryDate.length == 2) {
        _this.SelectData.entryDateBegin = dateFormat(
          "YYYY-mm-dd",
          new Date(_this.SelectData.entryDate[0])
        );
        _this.SelectData.entryDateEnd = dateFormat(
          "YYYY-mm-dd",
          new Date(_this.SelectData.entryDate[1])
        );
      } else {
        _this.SelectData.entryDateBegin = "";
        _this.SelectData.entryDateEnd = "";
      }
      let loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      GetInjuryMonthAlysisData(this.SelectData).then(function (data) {
        loading.close();
        _this.DataList = data;
        _this.lineChart();
        _this.pieChart();
        _this.barChart();
      });
      this.PageQuery.PageIndex = 1;
      this.GetListData();
    },
    GetDataDministrativeDivisions() {
      // const _this = this
      // GetDataDministrativeDivisionsList({
      //   pageSize: 1000,
      //   pageIndex: 1,
      //   queryModel: {
      //     level : 2,
      //     showChildren : true
      //   }
      // }).then(function(data){
      //   _this.ProvinceList = data.entities
      //   _this.ProvinceList.unshift({
      //     areaName:"-请选择-",
      //     code:""
      //   })
      // });
    },
    ProvinceChange() {
      const _this = this;
      _this.SelectData.CityCode = "";
      _this.ProvinceList.map((x) => {
        if (x.code == _this.SelectData.ProvinceCode) {
          _this.CityList = JSON.parse(JSON.stringify(x.children));
          _this.CityList.unshift({
            areaName: "-请选择-",
            code: "",
          });
        }
      });
    },
    CityChange() {
      const _this = this;
      _this.SelectData.RegionCode = "";
      _this.ProvinceList.map((x) => {
        if (x.code == _this.SelectData.ProvinceCode) {
          _this.RegionList = JSON.parse(
            JSON.stringify(
              x.children.filter(
                (o) => o.level == 4 && o.parentCode == _this.SelectData.CityCode
              )
            )
          );
          _this.RegionList.unshift({
            areaName: "-请选择-",
            code: "",
          });
        }
      });
    },
    // 明细列表
    GetListData() {
      const _this = this;
      try {
        _this.loading = true;
        if (_this.SelectData.entryDate.length == 2) {
          _this.SelectData.entryDateBegin = dateFormat(
            "YYYY-mm-dd",
            new Date(_this.SelectData.entryDate[0])
          );
          _this.SelectData.entryDateEnd = dateFormat(
            "YYYY-mm-dd",
            new Date(_this.SelectData.entryDate[1])
          );
        } else {
          _this.SelectData.entryDateBegin = "";
          _this.SelectData.entryDateEnd = "";
        }
        _this.PageQuery.queryModel = _this.SelectData;
        GetDataInjuryAffirmBillListByPageQuery(this.PageQuery).then(function (
          data
        ) {
          _this.loading = false;
          data.entities.forEach((e) => {
            e.isDeath = e.isDeath ? "是" : "否";
            e.sex = e.sex == 0 ? "男" : e.sex == 1 ? "女" : "未知";
            if (e.injuryTime)
              e.injuryTime = dateFormat("YYYY-mm-dd", new Date(e.injuryTime));
            // if(e.reviewSignatureTime)e.reviewSignatureTime=_this.dateFormat('YYYY-mm-dd',new Date(e.reviewSignatureTime))
          });
          _this.detailedData = data.entities;
          _this.total = data.totalCount;
        });
      } catch (e) {
        _this.loading = false;
        console.log(e);
      }
    },

    //选中事件
    handleSelectionChange({ records }) {
      this.multipleSelection = records;
    },
    selectAllChangeEvent({ checked, records }) {
      this.multipleSelection = records;
    },
    //清空
    clearCheckboxRow() {
      this.$refs.multipleTable.clearCheckboxRow();
      this.multipleSelection = [];
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.PageIndex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.PageIndex = currentPage;
      }
      this.GetListData();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.GetListData();
    },
    exportExcel() {
      if (this.multipleSelection.length == 0) {
        try {
          let loading = this.$loading({
            lock: true,
            text: "导出中..",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          if (this.SelectData.entryDate.length == 2) {
            this.SelectData.entryDateBegin = dateFormat(
              "YYYY-mm-dd",
              new Date(this.SelectData.entryDate[0])
            );
            this.SelectData.entryDateEnd = dateFormat(
              "YYYY-mm-dd",
              new Date(this.SelectData.entryDate[1])
            );
          } else {
            this.SelectData.entryDateBegin = "";
            this.SelectData.entryDateEnd = "";
          }
          ExportInjuryAffirmBill(this.SelectData, "工伤事故发生月份分析").then(
            (result) => {
              loading.close();
              if (result.response.status == 500) {
                this.$message.warning("查询到的数据为空");
              }
            }
          );
        } catch (e) {
          loading.close();
          console.log(e);
        }
      } else {
        this.export2Excel();
      }
    },
    export2Excel() {
      const v = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径

        const tHeader = [
          ...Enumerable.from(v.InjuryAffirmBillList)
            .select((item) => {
              return item.label;
            })
            .toArray(),
        ]; // 标题
        const filterVal = [
          ...Enumerable.from(v.InjuryAffirmBillList)
            .select((item) => {
              return item.prop;
            })
            .toArray(),
        ]; // 导出的字段名

        const list =
          v.multipleSelection.length == 0 ? v.DataList : v.multipleSelection;

        const data = v.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `工伤事故发生月份分析`);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
</style>
<style lang='scss' scoped>
@import "../../common/css/Hbn_modules/hbn-base-model";
.hbn-container {
  .hbn-operation {
    display: flex;
    align-items: baseline;
    .el-input {
      width: 200px;
      margin-left: 10px;
      ::v-deep .el-input__inner {
        border-color: transparent;
        &:focus {
          border-color: #4dc4e2;
        }
      }
    }
  }
  .operation-btn {
    display: flex;
    align-items: center;
    .el-button {
      width: 55px;
      height: 32px;
      background: #f7971e;
      border: 0;
      color: #ffffff;
      border-radius: 2px;
    }
    span {
      cursor: pointer;
      color: #0747a6;
      margin-left: 30px;
    }
  }
  .screen-item {
    margin-top: 20px;
  }
}
</style>

<style scoped>
.search-form {
  padding: 10px 0;
}

.search-form /deep/ .is-guttered {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.custom-table-header > th {
  background: #dfdfdf !important;
}
.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}
.hbn-content /deep/ .el-table .cell {
  color: #32383d;
}
</style>